import { render, staticRenderFns } from "./roleAdd.vue?vue&type=template&id=72311f5f&scoped=true&"
import script from "./roleAdd.vue?vue&type=script&lang=js&"
export * from "./roleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72311f5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72311f5f')) {
      api.createRecord('72311f5f', component.options)
    } else {
      api.reload('72311f5f', component.options)
    }
    module.hot.accept("./roleAdd.vue?vue&type=template&id=72311f5f&scoped=true&", function () {
      api.rerender('72311f5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting/roleManager/roleAdd.vue"
export default component.exports